




























import Vue from "vue";
import SideBarMenu from "./components/Menu/SideBarMenu.vue";
import Alert from "./components/Alert.vue";
import LoadingDialog from "./components/Dialogs/LoadingDialog.vue";
import { bus } from "./main";
import { router } from "./_router";

export default Vue.extend({
  name: "App",
  components: {
    SideBarMenu,
    Alert,
    LoadingDialog
  },
  data: () => ({
    status: false
  })
});
